import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
var generateStyle = function generateStyle(componentTheme, props) {
  return {
    targetContainerWrapper: _objectSpread(_objectSpread({
      maxWidth: '100%',
      display: 'flex',
      alignItems: 'center'
    }, props.justifyContent === 'left' && {
      justifyContent: 'left'
    }), props.justifyContent === 'center' && {
      justifyContent: 'center'
    }),
    targetContainerMain: {
      position: 'relative',
      marginTop: componentTheme.targetContainerMainMargin,
      /* IE11 bugfix */
      maxWidth: 'calc(100% - 0.01px)'
    },
    image: {
      maxWidth: '100%',
      maxHeight: '50rem'
    },
    mainContainerContentWrapper: {
      maxWidth: '100%',
      display: 'inline-block',
      flex: '1',
      alignItems: 'center'
    },
    mainContainerContent: {
      position: 'relative',
      width: '100%',
      height: '100%',
      cursor: 'pointer'
    }
  };
};
export default generateStyle;